import React from 'react'

// import { useState } from 'react';
import { Box} from '@mui/material';
import { Container } from '@mui/material';
// , TextField
// import  from '@mui/material';
// import Grid from '@mui/material/Grid';
// import FormControl from '@mui/material/FormControl';
// import Input from '@mui/material/Input';
// import InputLabel from '@mui/material/InputLabel';
// import Button from '@mui/material/Button';
// import Autocomplete from '@mui/material/Autocomplete';

import AddBankBranchForm from '../Components/AddBankBranchForm';

export default function AddBankBranchPage() {
  return (
    // component="main" 
    <Box sx={{ flexGrow: 1, p: 3 }}>
      <Container>
        <AddBankBranchForm/>
      </Container>
    


    </Box>
  )
}

// AddBankBranchPage

// `
// // "bank_branch_id":"",
// "bank_branch_name":"EastLongmont",
// "bank":"bank_id":1,
// "bank_branch_address":
//     "address":"123 test lane",
//     "addressTwo":"",
//     "city":"longmont",
//     "state":"CO",
//     "zip":"80501"
// ,
// "bank_branch_phone":"",
// "bank_branch_email":""
// // "branch_employees":""
// `
